/* @flow */

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetTags_tags_edges_node as Tag,
    GetTags as GetTagsQuery,
    TagType,
} from 'nutshell-graphql-types';

import GET_TAGS from '../queries/tags.graphql';

export const useGetTags = ({
    searchTerm,
    tagType,
}: {
    searchTerm?: string,
    tagType: TagType,
}): ({
    isLoading: boolean,
    errorMessage: ?string,
    tags: Tag[],
    refetch: () => Promise<*>,
    fetchMore: (searchTerm: string, tagType: TagType) => Promise<*>,
}) => {
    const {loading, data, refetch, fetchMore, error} = useQuery<GetTagsQuery, {}>(GET_TAGS, {
        notifyOnNetworkStatusChange: true,
        variables: {
            first: 500,
            input: {
                searchTerm,
                entityType: tagType,
            },
        },
    });

    return {
        isLoading: loading,
        errorMessage: safelyGetGraphQLErrorMessage(error),
        tags: data && data.tags && data.tags.edges ? data.tags.edges.map((edge) => edge.node) : [],
        refetch: refetch,
        fetchMore: (search: string, type: TagType) => {
            // $FlowIgnore
            return fetchMore({
                query: GET_TAGS,
                variables: {
                    input: {
                        entityType: type,
                        searchTerm: search,
                    },
                },
                updateQuery: (previousResult, {fetchMoreResult}) => {
                    if (!fetchMoreResult || !previousResult) return;

                    return fetchMoreResult && fetchMoreResult.tags && fetchMoreResult.tags.edges
                        ? fetchMoreResult.tags.edges.map((edge) => edge.node)
                        : [];
                },
            });
        },
    };
};
